// import './transactions.css'
// import '../changePassword/changePassword.css'
// import React, { useContext, useState ,useEffect } from 'react'
// import { AppContext } from '../../App'
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import Side from '../side/Side';
// const Transactions = () => {
//     const {route ,setLoader ,imgRoute}=useContext(AppContext)
//     const [send,setSend]=useState([])
//     const [recive,setRecive]=useState([])

//     const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' };

//     useEffect(()=>{
//         fetch(`${route}/acc/getMyTransactions/receiver`,{
//             headers:{
//                 "Authorization" :`Bearer ${sessionStorage.getItem("token")}`
//             }
//         })
//         .then(res=>res.json())
//         .then(data=>{
//     //  console.log(data)
//      if(data.data){
//         setRecive(data.data)
//      }
//         })
//         fetch(`${route}/acc/getMyTransactions/sender` ,{
//             headers:{
//                 "Authorization" :`Bearer ${sessionStorage.getItem("token")}`
//             }
//         })
//         .then(res=>res.json())
//         .then(data=>{
//      console.log(data)
//      if(data.data){
//         setSend(data.data)
//      }
//         })
//       },[])
//   return (
// <div className="trans">
//     <div className="container">
//         <div className="recive">
//         <h3>المستلمة</h3>
//         <div className="cards">
//             {recive.map((se,index)=>{
//                 return(
//                     <div className="re-card" key={index}>
//                         <div className="sender">{se.sender.id}: من</div>
//                         <div className="sender">من : {se.sender.name}</div>
//                         <div className="amount">{se.amount}: القيمة </div>
//                         <div className="amount">{new Date(se.created_at).toLocaleDateString('en-US', options)}</div>
//                     </div>
//                 )
//             })}
//         </div>
//         </div>
//         <div className="send">
//         <h3>المرسلة</h3>
//         <div className="cards">
//             {send.map((se,index)=>{
//                 return(
//                     <div className="se-card" key={index}>
//                         <div className="sender">الي : {se.receiver.id}</div>
//                         <div className="sender"> الي : {se.receiver.name}</div>
//                         <div className="amount">{se.amount}: القيمة </div>
//                         <div className="amount">{new Date(se.created_at).toLocaleDateString('en-US', options)}</div>
//                     </div>
//                 )
//             })}
//         </div>
//         </div>
//     </div>
//     <Side />
// </div>
//   )
// }

// export default Transactions
import './transactions.scss'
import React, { useContext, useEffect, useState } from 'react'
import { AppContext } from '../../App'
import Side from '../side/Side'

const Transactions = () => {
  const { route, setLoader } = useContext(AppContext)
  const [send, setSend] = useState([])
  const [receive, setReceive] = useState([])

  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  }

  useEffect(() => {
    setLoader(true)

    Promise.all([
      fetch(`${route}/acc/getMyTransactions/receiver`, {
        headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` }
      }).then(res => res.json()),

      fetch(`${route}/acc/getMyTransactions/sender`, {
        headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` }
      }).then(res => res.json())
    ])
      .then(([rec, sen]) => {
        setReceive(rec?.data?.reverse() || [])
        setSend(sen?.data?.reverse() || [])
      })
      .finally(() => setLoader(false))
  }, [])

  const renderEmpty = (text) => (
    <div className="empty">لا يوجد {text}</div>
  )

  return (
    <div className="transactions-page">
      <div className="transactions-container">

        {/* ===== Received ===== */}
        <div className="trans-box received">
          <h3>المستلمة</h3>

          {receive.length === 0
            ? renderEmpty("تحويلات واردة")
            : receive.map((tr, i) => (
              <div className="trans-card" key={i}>
                <div><span>من:</span> {tr.sender.name}</div>
                <div><span>الكود:</span> {tr.sender.id}</div>
                <div className="amount plus">+ {tr.amount}</div>
                <div className="date">
                  {new Date(tr.created_at).toLocaleDateString('ar-EG', options)}
                </div>
              </div>
            ))}
        </div>

        {/* ===== Sent ===== */}
        <div className="trans-box sent">
          <h3>المرسلة</h3>

          {send.length === 0
            ? renderEmpty("تحويلات صادرة")
            : send.map((tr, i) => (
              <div className="trans-card" key={i}>
                <div><span>إلى:</span> {tr.receiver.name}</div>
                <div><span>الكود:</span> {tr.receiver.id}</div>
                <div className="amount minus">- {tr.amount}</div>
                <div className="date">
                  {new Date(tr.created_at).toLocaleDateString('ar-EG', options)}
                </div>
              </div>
            ))}
        </div>

      </div>

      <Side />
    </div>
  )
}

export default Transactions
